import React, { useEffect, useState } from "react";
import firebase, { storage } from '../../config/firebase';
import { ref, getDownloadURL, uploadBytesResumable, deleteObject } from "firebase/storage";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import { Autocomplete, Card, IconButton, TextField } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputMask from 'react-input-mask';
import IntlCurrencyInput from "react-intl-currency-input";
import BackButton from "../../components/backButton/BackButton";
import { useSelector } from 'react-redux';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageZoom from '../../components/imageZoom';
import Button from '@mui/material/Button';
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import AlertDialog from "../../components/dialog";
import AlertDialogCertificate from "../../components/dialog/indexCertificate";
import userService from "../../service/user.service";


require('firebase/auth')

function NewEmbarcador() {

    const { id } = useParams();

    let navigate = useNavigate();
    const location = useLocation();

    const user = useSelector(state => state.user);

    const [view, setView] = useState(location.state?.viewOnly || false);

    const [socialName, setSocialName] = useState("");
    const [nameFantasy, setNameFantasy] = useState("");
    const [documentNumber, setDocumentNamber] = useState("");
    const [inscricaoEstadual, setInscricaoEstadual] = useState("");

    const [phoneNumberFirst, setPhoneNumberFirst] = useState("");
    const [phoneNumberSecond, setPhoneNumberSecond] = useState("");

    const [cep, setCep] = useState("");
    const [neighborhood, setNeighborhood] = useState("");//bairro
    const [street, setStreet] = useState("");//endereco
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [numeroEndereco, setNumeroEndereco] = useState("");
    const [complement, setComplement] = useState("");

    const [serie, setSerie] = useState("");
    const [number, setNumber] = useState("");
    const [typeEmitente, setTypeEmitente] = useState("");
    const [typeEmissao, setTypeEmissao] = useState("Normal");
    const [responsavelSeguro, setResponsavelSeguro] = useState("Próprio");

    const [msgTipo, setMsgTipo] = useState();
    const [carregando, setCarregando] = useState(0);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState();
    const [title, setTitle] = useState();

    const [photo, setPhoto] = useState(null);
    const [photoPreview, setPhotoPreview] = useState(null);
    const [passwordCertificate, setPasswordCertificate] = useState(null);
    const [documentCertificate, setDocumentCertificate] = useState(null);
    const [openCertificate, setOpenCertificate] = useState(false);
    const [origem, setOrigem] = useState(null);

    const [serialNumber, setSerialNumber] = useState(null);
    const [issuerName, setIssuerName] = useState(null);
    const [notValidBefore, setNotValidBefore] = useState(null);
    const [notValidAfter, setNotValidAfter] = useState(null);
    const [thumprint, setThumprint] = useState(null);
    const [subjectName, setSubjectName] = useState(null);
    const [cpfCnpj, setCpfCnpj] = useState(null);
    const [nameCompany, setNameCompany] = useState(null);

    const [documentCertificateInfo, setDocumentCertificateInfo] = useState(null);

    const [contatos, setContatos] = useState([createContatos()]);
    const [groups, setGroups] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [paymentConditions, setPaymentConditions] = useState([]);
    const [creditLimit, setCreditLimit] = useState("");
    // Mantem multiplas condicoes de pagamento selecionadas no financeiro.
    // Ex.: ["id_condicao_1", "id_condicao_2"].
    const [selectedPaymentConditionIds, setSelectedPaymentConditionIds] = useState([]);
    const [financialObservation, setFinancialObservation] = useState("");

    const currencyConfig = {
        locale: "pt-BR",
        formats: {
            number: {
                BRL: {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                },
            },
        },
    };

    const normalizeCreditLimitValue = (value) => {
        if (value === null || value === undefined || value === "") return "";
        if (typeof value === "number") return value;

        const onlyDigits = String(value)
            .replace(/\s/g, "")
            .replace("R$", "")
            .replace(/\D/g, "")
            .slice(0, 9);

        if (!onlyDigits) return "";

        return Number(onlyDigits) / 100;
    };

    function createContatos() {
        return {
            nome: '',
            funcao: '',
            telefone: '',
            email: '',
            recebeEmail: false,
        };
    }

    const validateRequiredFields = () => {
        const missing = [];

        const inputEl = document.getElementById('documentNumber');
        const stateVal = documentNumber ?? '';
        const inputVal = inputEl && inputEl.value ? inputEl.value : '';
        const rawDoc = String(stateVal).trim() !== '' ? String(stateVal) : String(inputVal);
        const docDigits = rawDoc.replace(/\D/g, '');

        if (!docDigits || docDigits.length === 0) missing.push('CNPJ');
        if (!socialName || !String(socialName).trim()) missing.push('Razão Social');
        if (!inscricaoEstadual || !String(inscricaoEstadual).trim()) missing.push('Inscrição Estadual');
        if (!nameFantasy || !String(nameFantasy).trim()) missing.push('Nome Fantasia');
        if (!cep || !String(cep).trim()) missing.push('CEP');
        if (!street || !String(street).trim()) missing.push('Logradouro');
        if (!numeroEndereco || !String(numeroEndereco).trim()) missing.push('Número');
        if (!neighborhood || !String(neighborhood).trim()) missing.push('Bairro');
        if (!city || !String(city).trim()) missing.push('Cidade');
        if (!state || !String(state).trim()) missing.push('Estado');
        // Regra do financeiro: condicao de pagamento e obrigatoria.
        if (!Array.isArray(selectedPaymentConditionIds) || selectedPaymentConditionIds.length === 0) missing.push('Condição de pagamento');

        if (missing.length) {
            setTitle('Campos obrigatórios');
            setMsg('Preencha os campos: ' + missing.join(', '));
            setMsgTipo('erro');
            setOpen(true);
            return false;
        }
        return true;
    }

    const handleChangeMaisContato = (index, field, value) => {
        const newContatos = [...contatos];
        newContatos[index][field] = value;
        setContatos(newContatos);
    };

    const adicionarContato = () => {
        setContatos([...contatos, createContatos()]);
    };
    const removerContato = (index) => {
        setContatos(contatos.filter((_, i) => i !== index));
    };

    const db = firebase.firestore();

    useEffect(() => {
        db.collection('tb_group').get()
            .then(snapshot => {
                const list = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
                setGroups(list);
            })
            .catch(err => console.error('Erro carregando grupos:', err));
    }, []);

    useEffect(() => {
        // Carrega os modelos de condicao de pagamento para o seletor da secao financeira.
        db.collection('paymentCondition').get()
            .then(snapshot => {
                const list = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
                setPaymentConditions(list);
            })
            .catch(err => console.error('Erro carregando condicoes de pagamento:', err));
    }, []);

    useEffect(() => {


        if (id) {

            firebase.firestore().collection('shipper').doc(id)
                .get().then(async (result) => {

                    var data = result.data();
                    if (id) {
                        setSocialName(data.dataPersonal.socialName)
                        setDocumentNamber(data.dataPersonal.documentNumber)
                        setNameFantasy(data.dataPersonal.nameFantasy)
                        setInscricaoEstadual(data.dataPersonal.inscricaoEstadual)
                        // suporta contact como object (antigo) ou array (novo)
                        if (Array.isArray(data.contact)) {
                            setContatos(data.contact);
                        } else if (data.contact) {
                            setPhoneNumberFirst(data.contact.phoneNumberFirst || "");
                            setPhoneNumberSecond(data.contact.phoneNumberSecond || "");
                        }

                        setCep(data.address.cep)
                        setStreet(data?.address.street)
                        setNeighborhood(data?.address.neighborhood)
                        setCity(data?.address.city)
                        setState(data?.address.state)
                        setNumeroEndereco(data?.address.numeroEndereco)
                        setComplement(data?.address.complement)

                        setSerie(data.mdfe.serie)
                        setNumber(data.mdfe.number)
                        setTypeEmitente(data.mdfe.typeEmitente)
                        setTypeEmissao(data.mdfe.typeEmissao)
                        setResponsavelSeguro(data.mdfe.responsavelSeguro)
                        setDocumentCertificate(data.infoCertificate?.certificate)

                        setPhotoPreview(data.logo)

                        if (Array.isArray(data.groupVisualizer)) {
                            setSelectedGroups(data.groupVisualizer.map(g => g.uid));
                        }

                        setCreditLimit(normalizeCreditLimitValue(data?.financial?.creditLimit))
                        // Compatibilidade: le array novo (paymentConditionIds)
                        // ou converte campo legado unico (paymentConditionId) para array.
                        const paymentConditionIds = Array.isArray(data?.financial?.paymentConditionIds)
                            ? data.financial.paymentConditionIds
                            : (data?.financial?.paymentConditionId ? [data.financial.paymentConditionId] : [])
                        setSelectedPaymentConditionIds(Array.isArray(paymentConditionIds) ? paymentConditionIds : [])
                        setFinancialObservation(data?.financial?.observation || "")


                        setPasswordCertificate(data.infoCertificate?.passwordCertificate ? data.infoCertificate?.passwordCertificate : "")
                        setSerialNumber(data.infoCertificate?.serialNumber ? data.infoCertificate?.serialNumber : "")
                        setIssuerName(data.infoCertificate?.issuerName ? data.infoCertificate?.issuerName : "")
                        setNotValidBefore(data.infoCertificate?.notValidBefore ? data.infoCertificate?.notValidBefore : "")
                        setNotValidAfter(data.infoCertificate?.notValidAfter ? data.infoCertificate?.notValidAfter : "")
                        setThumprint(data.infoCertificate?.thumbprint ? data.infoCertificate?.thumbprint : "")
                        setSubjectName(data.infoCertificate?.subjectName ? data.infoCertificate?.subjectName : "")
                        setCpfCnpj(data.infoCertificate?.cpfCnpj ? data.infoCertificate?.cpfCnpj : "")
                        setNameCompany(data.infoCertificate?.nameCompany ? data.infoCertificate?.nameCompany : "")
                    }



                }).catch(error => {
                    setCarregando(0)
                    console.log(error)
                });
        }


    }, [carregando]);

    //Função para consultar CEP
    function buscarCep(input) {

        if (input != null && input.length < 8) {
            return;
        } else {

            fetch('https://viacep.com.br/ws/' + input + '/json/', { mode: 'cors' })
                .then((res) => res.json())
                .then((data) => {
                    if (data.hasOwnProperty("erro")) {
                        alert('CEP não existente');
                    } else {

                        setStreet(data?.logradouro)
                        setNeighborhood(data?.bairro)
                        setCity(data?.localidade)
                        setState(data?.uf)
                        setNumeroEndereco(data?.numero)
                        setComplement(data?.complemento)

                    }
                })
                .catch(err => console.log(err));
        }
    }

    function buscarCNPJ(input) {
        if (input.length === 14) {
            fetch('https://open.cnpja.com/office/' + input, { mode: 'cors' })
                .then((res) => res.json())
                .then((data) => {
                    if (data.hasOwnProperty("erro")) {
                        alert('CNPJ não existente');
                    } else {
                        setSocialName(data?.company?.name)
                        setDocumentNamber(data?.taxId)
                        setNameFantasy(data?.alias ? data?.alias : data?.company?.name)
                    }
                })
                .catch(err => console.log(err));
        } else if (input.length === 18) {
            const inputLimpo = input.replace(/[^\d]/g, "");
            fetch('https://open.cnpja.com/office/' + inputLimpo, { mode: 'cors' })
                .then((res) => res.json())
                .then((data) => {
                    if (data.hasOwnProperty("erro")) {
                        alert('CNPJ não existente');
                    } else {
                        setSocialName(data?.company?.name)
                        setDocumentNamber(data?.taxId)
                        setNameFantasy(data?.alias ? data?.alias : data?.company?.name)
                    }
                })
                .catch(err => console.log(err));
        } else {
            return;
        }
    }

    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            const file = e.target.files[0];
            setPhoto(file);

            const reader = new FileReader();
            reader.onload = (event) => {
                setPhotoPreview(event.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    async function save() {
        if (!validateRequiredFields()) return;
        setCarregando(1);

        let photoURL = null;
        if (photo) {
            try {
                const imageBitmap = await createImageBitmap(photo);
                const { width, height } = imageBitmap;

                if (width > 606 || height > 242) {
                    alert("A imagem selecionada e grande. Ela sera redimensionada para no maximo 606x242 pixels.");
                }

                const storageRef = ref(storage, `files/logo/${nameFantasy}`);

                await uploadBytesResumable(storageRef, photo);

                photoURL = await getDownloadURL(storageRef);

            } catch (error) {
                console.error("Erro ao salvar:", error);
            }
        };

        var history = {
            created: new Date()
        }

        var dataPersonal = {
            socialName: socialName,
            documentNumber: documentNumber,
            nameFantasy: nameFantasy,
            inscricaoEstadual: inscricaoEstadual,
        }

        const filteredContatos = (contatos || []).filter(c => c.nome || c.funcao || c.telefone || c.email || c.recebeEmail);
        var contact = filteredContatos.length ? filteredContatos : [];

        var address = {
            cep: cep,
            street: street,
            neighborhood: neighborhood,
            city: city,
            state: state,
            numeroEndereco: numeroEndereco,
            complement: complement,
        }

        var mdfe = {
            serie: serie,
            number: number,
            typeEmitente: typeEmitente,
            typeEmissao: typeEmissao,
            responsavelSeguro: responsavelSeguro
        }

        var infoCertificate = {
            certificate: documentCertificate ? documentCertificate : "",
            passwordCertificate: passwordCertificate ? passwordCertificate : "",
            serialNumber: documentCertificateInfo?.serial_number ? documentCertificateInfo?.serial_number : "",
            issuerName: documentCertificateInfo?.issuer_name ? documentCertificateInfo?.issuer_name : "",
            notValidBefore: documentCertificateInfo?.not_valid_before ? documentCertificateInfo?.not_valid_before : "",
            notValidAfter: documentCertificateInfo?.not_valid_after ? documentCertificateInfo?.not_valid_after : "",
            thumbprint: documentCertificateInfo?.thumbprint ? documentCertificateInfo?.thumbprint : "",
            subjectName: documentCertificateInfo?.subject_name ? documentCertificateInfo?.subject_name : "",
            cpfCnpj: documentCertificateInfo?.cpf_cnpj ? documentCertificateInfo?.cpf_cnpj : "",
            nameCompany: documentCertificateInfo?.nome_razao_social ? documentCertificateInfo?.nome_razao_social : ""
        }
        // Resolve as condicoes selecionadas para salvar IDs e descricoes.
        // Isso evita depender so do ID para renderizacao futura em telas/listagens.
        const selectedPaymentConditions = paymentConditions.filter(condition => selectedPaymentConditionIds.includes(condition.id));
        // Mantem id e descricao para facilitar exibicao futura e evitar nova busca para renderizacao simples.
        var financial = {
            creditLimit: creditLimit || creditLimit === 0 ? creditLimit : "",
            paymentConditionIds: selectedPaymentConditions.map((condition) => condition.id),
            paymentConditionDescriptions: selectedPaymentConditions.map((condition) => condition.description).filter(Boolean),
            // Campos legados mantidos para retrocompatibilidade.
            paymentConditionId: selectedPaymentConditions[0]?.id ? selectedPaymentConditions[0].id : "",
            paymentConditionDescription: selectedPaymentConditions[0]?.description ? selectedPaymentConditions[0].description : "",
            observation: financialObservation ? financialObservation : "",
        }
        const groupVisualizer = (selectedGroups || []).map(uid => ({ uid }));
        var dataAll = {
            dataPersonal: dataPersonal,
            contact: contact,
            address: address,
            history: history,
            logo: photoURL,
            mdfe: mdfe,
            infoCertificate: infoCertificate,
            financial: financial,
            groupVisualizer: groupVisualizer,
        }

        try {
            const docRef = await db.collection("shipper").add(dataAll);
            try {
                const users = await userService.getUsers();

                const updatePromises = users
                    .filter((user) => user.viewALL === true)
                    .map(async (user) => {
                        const updatedAffiliates = Array.isArray(user.uidShipperAffiliates)
                            ? [...user.uidShipperAffiliates, docRef.id]
                            : [docRef.id];

                        return userService.updateUser(user.id, {
                            uidShipperAffiliates: updatedAffiliates,
                        });
                    });

                await Promise.all(updatePromises);
            }
            catch (error) {
                console.error(error);
                setMsgTipo('erro');
                setTitle('Ops!');
                setMsg('Houve um problema interno ao salvar o uid embarcador dentro dos usuarios com viewALL');
                setOpen(true);
            }

            setCarregando(0);
            setMsgTipo('sucesso');
            navigate("/embarcador");
        } catch (error) {
            setMsgTipo('erro');
            setCarregando(0);
            setTitle('Ops!');
            setMsg('Houve um problema interno ao recuperar os dados do Embarcador');
            setOpen(true);
        }
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseCertificate = () => {

        setOpenCertificate(false);
    };

    async function update() {

        if (!validateRequiredFields()) return;
        setCarregando(1)
        let photoURL = null;
        if (photo) {
            try {

                const imageBitmap = await createImageBitmap(photo);
                const { width, height } = imageBitmap;

                if (width > 606 || height > 242) {
                    alert("A imagem selecionada e grande. Ela sera redimensionada para no maximo 606x242 pixels.");
                }

                const storageRef = ref(storage, `files/logo/${nameFantasy}`);

                await uploadBytesResumable(storageRef, photo);

                photoURL = await getDownloadURL(storageRef);

            } catch (error) {
                console.error("Erro ao salvar:", error);
            }
        };

        var history = {
            created: new Date()
        }

        var dataPersonal = {
            socialName: socialName,
            documentNumber: documentNumber,
            nameFantasy: nameFantasy,
            inscricaoEstadual: inscricaoEstadual ? inscricaoEstadual : '',
        }

        const filteredContatos = (contatos || []).filter(c => c.nome || c.funcao || c.telefone || c.email || c.recebeEmail);
        var contact = filteredContatos.length ? filteredContatos : [];

        var address = {
            cep: cep ? cep : '',
            street: street ? street : '',
            neighborhood: neighborhood ? neighborhood : '',
            city: city ? city : '',
            state: state ? state : '',
            numeroEndereco: numeroEndereco ? numeroEndereco : '',
            complement: complement ? complement : '',
        }

        var mdfe = {
            serie: serie ? serie : '',
            number: number ? number : '',
            typeEmitente: typeEmitente ? typeEmitente : '',
            typeEmissao: typeEmissao ? typeEmissao : 'Normal',
            responsavelSeguro: responsavelSeguro ? responsavelSeguro : 'Próprio'
        }

        if (documentCertificate && Object.keys(documentCertificate).length > 0) {
            var infoCertificate = {
                certificate: documentCertificate || infoCertificate?.certificate || "",
                passwordCertificate: passwordCertificate || infoCertificate?.passwordCertificate || "",
                serialNumber: documentCertificateInfo?.serial_number || serialNumber || "",
                issuerName: documentCertificateInfo?.issuer_name || issuerName || "",
                notValidBefore: documentCertificateInfo?.not_valid_before || notValidBefore || "",
                notValidAfter: documentCertificateInfo?.not_valid_after || notValidAfter || "",
                thumbprint: documentCertificateInfo?.thumbprint || thumprint || "",
                subjectName: documentCertificateInfo?.subject_name || subjectName || "",
                cpfCnpj: documentCertificateInfo?.cpf_cnpj || cpfCnpj || "",
                nameCompany: documentCertificateInfo?.nome_razao_social || nameCompany || ""
            }
        }
        else {
            var infoCertificate = {
                certificate: "",
                passwordCertificate: "",
                serialNumber: "",
                issuerName: "",
                notValidBefore: "",
                notValidAfter: "",
                thumbprint: "",
                subjectName: "",
                cpfCnpj: "",
                nameCompany: ""
            }
        }
        // Resolve as condicoes selecionadas para salvar IDs e descricoes.
        // Isso evita depender so do ID para renderizacao futura em telas/listagens.
        const selectedPaymentConditions = paymentConditions.filter(condition => selectedPaymentConditionIds.includes(condition.id));
        // Secao financeira persistida junto ao embarcador.
        var financial = {
            creditLimit: creditLimit || creditLimit === 0 ? creditLimit : "",
            paymentConditionIds: selectedPaymentConditions.map((condition) => condition.id),
            paymentConditionDescriptions: selectedPaymentConditions.map((condition) => condition.description).filter(Boolean),
            // Campos legados mantidos para retrocompatibilidade.
            paymentConditionId: selectedPaymentConditions[0]?.id ? selectedPaymentConditions[0].id : "",
            paymentConditionDescription: selectedPaymentConditions[0]?.description ? selectedPaymentConditions[0].description : "",
            observation: financialObservation ? financialObservation : "",
        }
        const groupVisualizer = (selectedGroups || []).map(uid => ({ uid }));
        var dataAll = {
            dataPersonal: dataPersonal,
            contact: contact,
            address: address,
            history: history,
            logo: photoURL,
            mdfe: mdfe,
            infoCertificate: infoCertificate,
            financial: financial,
            groupVisualizer: groupVisualizer,
        }

        try {
            await db.collection("shipper").doc(id).update(dataAll);

            setCarregando(0);
            setMsgTipo('sucesso');
            if (user?.viewALL) {
                navigate("/embarcador");
            }
            else {
                setTitle('Sucesso!');
                setMsg('Embarcador atualizado com sucesso!');
                setOpen(true);
            }
        } catch (error) {
            setMsgTipo('erro');
            setCarregando(0);
            setTitle('Ops!');
            setMsg('Houve um problema interno ao recuperar os dados do Embarcador');
            setOpen(true);
        }

    }


    const handleCreateSerie = (e) => {
        const value = e.target.value;

        if (value.length <= 3) {
            setSerie(value);

            //cria um sequencial para o campo number
            // const sequencial = parseInt(0, 10) + 1;
            // setNumber(sequencial.toString().padStart(9, '0')); // Preenche com zeros a esquerda ate 9 digitos

            if (!id || number === "") {
                const sequencial = parseInt(0, 10) + 1;
                setNumber(sequencial.toString().padStart(9, '0'));
            }

        }
    }


    const handleDelete = async (downloadUrl) => {
        try {
            // Extrair o caminho do arquivo a partir da URL
            const pathStart = downloadUrl.indexOf("/o/") + 3;
            const pathEnd = downloadUrl.indexOf("?", pathStart);
            const encodedPath = downloadUrl.substring(pathStart, pathEnd);
            const filePath = decodeURIComponent(encodedPath);

            // Referencia ao arquivo no Firebase Storage
            const fileRef = ref(storage, filePath);

            // Deletar o arquivo
            await deleteObject(fileRef);

            console.log("Certificado excluido com sucesso!");
        } catch (error) {
            console.error("Erro ao excluir o arquivo:", error);
            alert("Erro ao excluir o arquivo.");
        }
    };

    const handleClickOpen = () => {
        setOpenCertificate(true);
    };

    const handleUpload = (file, passwordCertificate, certInfo) => {

        if (!file) return;

        if (file && passwordCertificate) {

            if (certInfo) {
                setDocumentCertificateInfo(certInfo);
                setPasswordCertificate(passwordCertificate);
            }
            // return;
        }

        // return;

        var contest = file;

        const storageRef = ref(storage, `shipper/certificate/${id}/${contest.name}`);

        const uploadTask = uploadBytesResumable(storageRef, contest);

        uploadTask.on("state_changed",
            (snapshot) => {
                const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            },
            (error) => {
                alert(error)
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    if (origem === "documentCertificate") {
                        setDocumentCertificate(downloadURL)
                        setOpenCertificate(false)
                        setOrigem("")
                    }

                });
            })
    }

    function formatDate(dateString) {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date)) return "";
        return date.toLocaleDateString('pt-BR');
    }

    return (
        <>
            <NewMiniDrawer divOpen={

                <div
                    className="freight-content align-items-center"
                    style={{ paddingTop: '0px' }}
                >

                    {origem === "documentCertificate" ? (
                        <AlertDialogCertificate
                            handleClose={handleCloseCertificate}
                            open={openCertificate}
                            origem={origem}
                            handleUpload={handleUpload}
                        />
                    ) : (
                        <AlertDialog
                            handleClose={handleCloseCertificate}
                            open={openCertificate}
                            origem={origem}
                            handleUpload={handleUpload}
                        />
                    )}

                    <div className="form-cadastro">

                        <h2>
                            Cadastro de Embarcador
                        </h2>

                        <div className="form-signin mx-auto mb-4 mb-lg-6">


                            <Card
                                sx={{ padding: 2 }}
                                className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3 align-items-center"
                                style={{
                                    background: "#ffffff",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                    borderRadius: "16px",
                                }}
                            >
                                <div className="d-flex align-items-center justify-content-between mb-3" style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <i className="fa fa-user" style={{ color: '#012443', fontSize: 20 }} aria-hidden="true"></i>
                                        <h4 className="mb-0" style={{ fontSize: 18, fontWeight: 600, color: '#012443' }}>
                                            Dados Principais <span style={{ color: "red" }}>*</span>
                                        </h4>
                                    </div>


                                </div>

                                <div className="form-signin mx-auto mb-4 mb-lg-6">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label htmlFor="documentNumber" className="form-label">CNPJ  <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                disabled={view}
                                                type="text"
                                                onChange={(e) => {
                                                    buscarCNPJ(e.target.value);
                                                    setDocumentNamber(e.target.value);
                                                }}
                                                value={documentNumber && documentNumber}
                                                className="form-control" id="documentNumber"
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <label htmlFor="socialName" className="form-label">Razão Social <span style={{ color: "red" }}>*</span></label>
                                            <input type="text"
                                                disabled={view}
                                                onChange={(e) => setSocialName(e.target.value)}
                                                value={socialName && socialName}
                                                className="form-control" id="socialName" />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-3">
                                            <label htmlFor="inscricaoEstadual" className="form-label">Inscrição Estadual <span style={{ color: "red" }}>*</span></label>
                                            <input disabled={view} type="text" onChange={(e) => setInscricaoEstadual(e.target.value)} value={inscricaoEstadual && inscricaoEstadual} className="form-control" id="inscricaoEstadual" />
                                        </div>

                                        <div className="col-md-4">
                                            <label htmlFor="nameFantasy" className="form-label">Nome Fantasia <span style={{ color: "red" }}>*</span></label>
                                            <input type="text"
                                                disabled={view}
                                                onChange={(e) => setNameFantasy(e.target.value)}
                                                value={nameFantasy && nameFantasy}
                                                className="form-control" id="nameFantasy" />
                                        </div>
                                    </div>
                                </div>
                            </Card>

                            <Card
                                sx={{ padding: 2 }}
                                className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                                style={{
                                    background: "#ffffff",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                    borderRadius: "16px",
                                }}
                            >
                                <div className="d-flex align-items-center justify-content-between mb-3" style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <i className="fa fa-map-marker" style={{ color: '#012443', fontSize: 20 }} aria-hidden="true"></i>
                                        <h4 className="mb-0" style={{ fontSize: 18, fontWeight: 600, color: '#012443' }}>
                                            Endereço <span style={{ color: "red" }}>*</span>
                                        </h4>
                                    </div>
                                    {/* no import / edit buttons as requested */}
                                </div>

                                <div className="form-signin mx-auto mb-4 mb-lg-6">
                                    <div className="row">
                                        <div className="col-3">
                                            <label htmlFor="cep" className="form-label">CEP <span style={{ color: "red" }}>*</span></label>
                                            <InputMask
                                                disabled={view}
                                                mask="99999-999"
                                                type="text"
                                                onChange={(e) => {
                                                    buscarCep(e.target.value);
                                                    setCep(e.target.value);
                                                }}
                                                value={cep && cep}
                                                className="form-control"
                                                id="cep"
                                            />
                                        </div>

                                        <div className="col-4">
                                            <label htmlFor="street" className="form-label">Logradouro <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                disabled={view}
                                                type="text"
                                                onChange={(e) => setStreet(e.target.value)}
                                                value={street && street}
                                                className="form-control"
                                                id="street"
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-3">
                                            <label htmlFor="numeroEndereco" className="form-label">Número <span style={{ color: "red" }}>*</span></label>
                                            <input disabled={view} type="text" onChange={(e) => setNumeroEndereco(e.target.value)} value={numeroEndereco && numeroEndereco} className="form-control" id="numeroEndereco" />
                                        </div>

                                        <div className="col-md-2">
                                            <label htmlFor="neighborhood" className="form-label">Bairro <span style={{ color: "red" }}>*</span></label>
                                            <input disabled={view} type="text"
                                                onChange={(e) => setNeighborhood(e.target.value)}
                                                value={neighborhood && neighborhood}
                                                className="form-control"
                                                id="neighborhood" />
                                        </div>

                                        <div className="col-md-2">
                                            <label htmlFor="city" className="form-label">Cidade <span style={{ color: "red" }}>*</span></label>
                                            <input disabled={view} type="text"
                                                onChange={(e) => setCity(e.target.value)}
                                                value={city && city}
                                                className="form-control"
                                                id="neighborhood" />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-3">
                                            <label htmlFor="state" className="form-label">Estado <span style={{ color: "red" }}>*</span></label>
                                            <input type="text" disabled={view}
                                                onChange={(e) => setState(e.target.value)}
                                                value={state && state}
                                                className="form-control" id="state" />
                                        </div>

                                        <div className="col-md-4">
                                            <label htmlFor="complement" className="form-label">Complemento</label>
                                            <input disabled={view} type="text" onChange={(e) => setComplement(e.target.value)} value={complement && complement} className="form-control" id="complement" />
                                        </div>
                                    </div>
                                </div>
                            </Card>

                            <Card
                                sx={{ padding: 2 }}
                                className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                                style={{
                                    background: "#ffffff",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                    borderRadius: "16px",
                                }}
                            >
                                <div className="form-signin mx-auto mb-4 mb-lg-6">
                                    <div className="row">
                                        <div className="col-12">
                                            <h4
                                                className="mb-3"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 10,
                                                    fontSize: 18,
                                                    fontWeight: 600,
                                                    color: "#012443",
                                                }}
                                            >
                                                <i
                                                    className="fa fa-address-book"
                                                    style={{ color: "#012443", fontSize: 20 }}
                                                    aria-hidden="true"
                                                />
                                                Contatos
                                            </h4>
                                        </div>

                                        {contatos.map((contato, index) => (
                                            <Card
                                                sx={{ padding: 2 }}
                                                className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                                                style={{
                                                    background: "#ffffff",
                                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                                    borderRadius: "16px",
                                                    position: "relative",
                                                    marginBottom: 16,
                                                    marginTop: 16,
                                                }}
                                                key={index}
                                            >
                                                <Button
                                                    style={{ position: "absolute", top: 8, right: 8, padding: 4, zIndex: 100 }}
                                                    color="error"
                                                    onClick={() => removerContato(index)}
                                                    disabled={contatos.length === 1 || view}
                                                    title="Remover contato"
                                                >
                                                    <DeleteIcon />
                                                </Button>

                                                <div key={index}>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <label htmlFor="nome" className="form-label">Nome</label>
                                                            <input disabled={view} type="text" onChange={(e) => handleChangeMaisContato(index, 'nome', e.target.value)} value={contato.nome} className="form-control" id="nome" />
                                                        </div>
                                                        <div className="col-md-2">
                                                            <label htmlFor="funcao" className="form-label">Função</label>
                                                            <input disabled={view} type="text" onChange={(e) => handleChangeMaisContato(index, 'funcao', e.target.value)} value={contato.funcao} className="form-control" id="funcao" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <label htmlFor="telefone" className="form-label">Telefone</label>
                                                            <InputMask disabled={view} mask="(99) 99999-9999" type="text" onChange={(e) => handleChangeMaisContato(index, 'telefone', e.target.value)} value={contato.telefone} className="form-control" id="telefone" />
                                                        </div>
                                                        <div className="col-md-2">
                                                            <label htmlFor="email" className="form-label">E-mail</label>
                                                            <input disabled={view} type="text" onChange={(e) => handleChangeMaisContato(index, 'email', e.target.value)} value={contato.email} className="form-control" id="email" />
                                                        </div>
                                                        <div className="col-md-2" style={{ marginTop: 30 }}>
                                                            <input
                                                                disabled={view}
                                                                type="checkbox"
                                                                onChange={(e) => handleChangeMaisContato(index, 'recebeEmail', e.target.checked)}
                                                                checked={contato.recebeEmail}
                                                                className="form-check-input"
                                                                id="recebeEmail"
                                                                style={{ accentColor: "#043124" }}
                                                            />
                                                            Receber E-mail
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                        ))}

                                        <Button

                                            sx={{
                                                width: "auto",
                                                minWidth: 180,
                                                marginLeft: 2,
                                                alignSelf: "flex-end",
                                                fontWeight: 500,
                                                color: '#ffffff',
                                                backgroundColor: '#012443',
                                                textTransform: 'none',
                                                '&:hover': {
                                                    backgroundColor: '#012443',
                                                    boxShadow: '0 6px 18px #012443',
                                                    transform: 'translateY(-2px)',
                                                    color: '#ffffff',
                                                },
                                                transition: 'all 0.18s ease-in-out'
                                            }}
                                            disabled={view}
                                            type="button"
                                            className="btn"
                                            onClick={adicionarContato}
                                        >
                                            + Adicionar Contato
                                        </Button>

                                    </div>
                                </div>
                            </Card>

                            <Card
                                sx={{ padding: 2 }}
                                className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                                style={{
                                    background: "#ffffff",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                    borderRadius: "16px",
                                }}
                            >
                                <div className="col-12">
                                    <h4
                                        className="mb-3"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 10,
                                            fontSize: 18,
                                            fontWeight: 600,
                                            color: "#012443",
                                        }}
                                    >
                                        <i className="fa fa-dollar-sign" style={{ color: "#012443", fontSize: 20 }} aria-hidden="true" />
                                        Financeiro
                                    </h4>
                                </div>

                                <div className="form-signin mx-auto mb-4 mb-lg-6">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label htmlFor="creditLimit" className="form-label">Limite de Credito</label>
                                            <IntlCurrencyInput
                                                disabled={view}
                                                currency="BRL"
                                                config={currencyConfig}
                                                onChange={(event, value) => setCreditLimit(normalizeCreditLimitValue(value))}
                                                value={creditLimit}
                                                className="form-control"
                                                id="creditLimit"
                                                placeholder="R$ 0,00"
                                                maxLength={15}
                                            />
                                        </div>

                                        {/* Campo alterado para multipla selecao:
                                            - obrigatorio (asterisco + validacao)
                                            - mantem dropdown aberto para selecao continua
                                            - grava lista de condicoes no financeiro do embarcador */}
                                        <div className="col-md-5">
                                            <label htmlFor="paymentConditionAutocomplete" className="form-label">
                                                Condição de pagamento <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <Autocomplete
                                                disabled={view}
                                                id="paymentConditionAutocomplete"
                                                size="small"
                                                multiple
                                                // Mantem o dropdown aberto apos cada selecao.
                                                // O usuario decide quando fechar (clique fora, ESC ou icone).
                                                disableCloseOnSelect
                                                // Mantem opcoes inativas visiveis apenas quando ja estiverem selecionadas.
                                                options={paymentConditions.filter((condition) => condition.active !== false || selectedPaymentConditionIds.includes(condition.id))}
                                                value={paymentConditions.filter((condition) => selectedPaymentConditionIds.includes(condition.id))}
                                                getOptionLabel={(option) => option.description || ""}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                onChange={(event, newValue) => {
                                                    // Persiste somente os IDs selecionados para simplificar o estado.
                                                    setSelectedPaymentConditionIds((newValue || []).map((item) => item.id));
                                                }}
                                                noOptionsText="Nenhuma condicao encontrada"
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label=""
                                                        placeholder="Selecione uma ou mais condicoes de pagamento"
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <li {...props} key={option.id}>
                                                        {option.description || option.id}
                                                        {option.observation && ` - ${option.observation}`}
                                                    </li>
                                                )}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-md-8">
                                            <label htmlFor="financialObservation" className="form-label">Observações</label>
                                            <textarea
                                                disabled={view}
                                                onChange={(e) => setFinancialObservation(e.target.value)}
                                                value={financialObservation}
                                                className="form-control"
                                                id="financialObservation"
                                                rows="3"
                                                placeholder="Digite observacoes financeiras"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Card>


                            <Card
                                sx={{ padding: 2 }}
                                className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                                style={{
                                    background: "#ffffff",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                    borderRadius: "16px",
                                }}
                            >
                                <div className="col-12">
                                    <h4
                                        className="mb-3"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 10,
                                            fontSize: 18,
                                            fontWeight: 600,
                                            color: "#012443",
                                        }}
                                    >
                                        <i className="fa fa-cog" style={{ color: "#012443", fontSize: 20 }} aria-hidden="true" />
                                        Parametros MDF-e
                                    </h4>
                                </div>

                                <div className="form-signin mx-auto mb-4 mb-lg-4">
                                    <div className="row">
                                        <div className="col-md-1">
                                            <label htmlFor="serie" className="form-label">Série</label>
                                            <input type="text" disabled={view}
                                                onChange={handleCreateSerie}
                                                value={serie && serie}
                                                className="form-control" id="documentNumber" />
                                        </div>

                                        <div className="col-md-3">
                                            <label htmlFor="number" className="form-label">Número</label>
                                            <input type="text" disabled={view}
                                                onChange={(e) => setNumber(e.target.value)}
                                                value={number && number}
                                                className="form-control" id="socialName" />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-2">
                                            <label htmlFor="typeEmitente" className="form-label">Tipo emitente </label>
                                            <select
                                                disabled={view}
                                                className="form-select"
                                                onChange={(e) => setTypeEmitente(e.target.value)}
                                                value={typeEmitente && typeEmitente}
                                                aria-label=""
                                            >
                                                <option defaultValue="">Selecione</option>
                                                <option value="1">Prestador de serviço</option>
                                                <option value="2">Carga propria{" "}</option>
                                                <option value="3">Contratante{" "}</option>
                                            </select>
                                        </div>

                                        <div className="col-md-2">
                                            <label htmlFor="typeEmissao" className="form-label">Tipo emissão</label>
                                            <select
                                                disabled={view}
                                                className="form-select"
                                                onChange={(e) => setTypeEmissao(e.target.value)}
                                                value={typeEmissao && typeEmissao}
                                                aria-label=""
                                            >
                                                <option defaultValue="">Selecione</option>
                                                <option value="1">Normal</option>
                                                <option value="2">Contigencia</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="responsavelSeguro" className="form-label">Responsável pelo seguro</label>
                                            <select
                                                disabled={view}
                                                className="form-select"
                                                onChange={(e) => setResponsavelSeguro(e.target.value)}
                                                value={responsavelSeguro && responsavelSeguro}
                                                aria-label=""
                                            >
                                                <option defaultValue="">Selecione</option>
                                                <option value="Próprio">Próprio</option>
                                                <option value="Fracionado">Fortio{" "}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-2">
                                            <label htmlFor="typeEmitente" className="form-label">Importar certificado </label>

                                            {documentCertificate ? (
                                                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                                    <li
                                                        style={{
                                                            background: "#f8f9fa",
                                                            border: "1px solid #e0e0e0",
                                                            borderRadius: "8px",
                                                            padding: "2px 3px",
                                                            marginBottom: "4px",
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                                                            transition: "all 0.3s ease"
                                                        }}
                                                    >
                                                        <span style={{ whiteSpace: 'nowrap' }}>
                                                            Certificado Validado âœ” - Validade: {formatDate(documentCertificateInfo?.not_valid_after) || formatDate(notValidBefore)} - {documentCertificateInfo?.nome_razao_social || subjectName}
                                                        </span>
                                                        <IconButton
                                                            disabled={view}
                                                            aria-label="Excluir"
                                                            size="small"
                                                            color="error"
                                                            onClick={() => { handleDelete(documentCertificate); setDocumentCertificate(null); }}
                                                            sx={{
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(211, 47, 47, 0.1)',
                                                                    transform: 'scale(1.1)',
                                                                },
                                                                transition: 'all 0.2s ease-in-out',
                                                                padding: '4px',
                                                                borderRadius: '50%',
                                                                border: '1px solid transparent',
                                                                '&:focus': {
                                                                    outline: 'none',
                                                                    border: '1px solid #d32f2f'
                                                                }
                                                            }}
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </li>
                                                </ul>
                                            )
                                                :
                                                <Button
                                                    disabled={view}
                                                    variant="contained"
                                                    onClick={(e) => {
                                                        handleClickOpen();
                                                        setOrigem("documentCertificate");
                                                    }}
                                                    sx={{
                                                        backgroundColor: '#012443',
                                                        color: '#ffffff',
                                                        textTransform: 'none',
                                                        '&:hover': {
                                                            backgroundColor: '#012443',
                                                            boxShadow: '0 6px 18px #012443',
                                                            transform: 'translateY(-2px)'
                                                        },
                                                        transition: 'all 0.18s ease-in-out'
                                                    }}
                                                >
                                                    Importar
                                                </Button>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </Card>

                            <Card
                                sx={{ padding: 2 }}
                                className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                                style={{
                                    background: "#ffffff",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                    borderRadius: "16px",
                                }}
                            >
                                <div className="col-12">
                                    <h4 className="mb-3" style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 18, fontWeight: 600, color: "#012443" }}>
                                        <i className="fa fa-users" style={{ color: "#012443", fontSize: 20 }} aria-hidden="true" />
                                        Grupos
                                    </h4>

                                    <div style={{ marginTop: 8 }}>
                                        <Autocomplete
                                            multiple
                                            disableCloseOnSelect
                                            disabled={view}
                                            id="groups-autocomplete-shipper"
                                            size="small"
                                            sx={{ width: "35%" }}
                                            value={groups.filter((group) => selectedGroups.includes(group.id))}
                                            getOptionLabel={(option) => option.name || option.title || ""}
                                            options={groups}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            onChange={(event, newValue) => {
                                                setSelectedGroups(newValue.map((group) => group.id));
                                            }}
                                            clearOnBlur
                                            noOptionsText="Nenhum grupo encontrado"
                                            renderInput={(params) => (
                                                <TextField {...params} label="" placeholder="Selecione os grupos" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.id}>
                                                    {option.name || option.title || option.id}
                                                    {option.description && ` - ${option.description}`}
                                                </li>
                                            )}
                                            filterOptions={(options, { inputValue }) => {
                                                const normalizedInput = inputValue.trim().toLowerCase();
                                                return options.filter((option) => {
                                                    const name = String(option.name || option.title || "").toLowerCase();
                                                    const description = String(option.description || "").toLowerCase();
                                                    return name.includes(normalizedInput) || description.includes(normalizedInput);
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </Card>

                            {user?.perfil !== '' ? (

                                <Card
                                    sx={{ padding: 2 }}
                                    className="form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3 align-items-center"
                                    style={{
                                        background: "#ffffff",
                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                        borderRadius: "16px",
                                    }}
                                >
                                    <div className="form-signin mx-auto mb-4 mb-lg-6">
                                        <div className="row">
                                            <div className="col-12">
                                                <h4
                                                    className="mb-3"
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 10,
                                                        fontSize: 18,
                                                        fontWeight: 600,
                                                        color: "#012443",
                                                    }}
                                                >
                                                    <i className="fa fa-image" style={{ color: "#012443", fontSize: 20 }} aria-hidden="true" />
                                                    Logo
                                                </h4>
                                            </div>

                                            <div className="col-md-2">
                                                {photoPreview ? (
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <ImageZoom
                                                                title=""
                                                                name="photo"
                                                                source={photoPreview}
                                                                height="100"
                                                                width="100"
                                                            />
                                                            <Button
                                                                disabled={view}
                                                                variant="outlined"
                                                                onClick={() => setPhotoPreview(null)}
                                                                sx={{
                                                                    color: '#012443',
                                                                    borderColor: '#012443',
                                                                    textTransform: 'none',
                                                                    '&:hover': {
                                                                        backgroundColor: '#043124',
                                                                        color: '#fff',
                                                                        borderColor: '#043124',
                                                                        boxShadow: '0 6px 18px rgba(4,49,36,0.12)',
                                                                        transform: 'translateY(-2px)'
                                                                    },
                                                                    transition: 'all 0.18s ease-in-out'
                                                                }}
                                                                startIcon={<i className="fa fa-trash" style={{ color: '#012443' }} />}
                                                            >
                                                                Remover
                                                            </Button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <input
                                                            disabled={view}
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={handleFileChange}
                                                            style={{ display: "none" }}
                                                            id="upload-image"
                                                        />
                                                        <label htmlFor="upload-image">
                                                            <Button
                                                                disabled={view}
                                                                variant="contained"
                                                                component="span"
                                                                onClick={() => { }}
                                                                sx={{
                                                                    backgroundColor: '#012443',
                                                                    color: '#ffffff',
                                                                    textTransform: 'none',
                                                                    '&:hover': {
                                                                        backgroundColor: '#012443',
                                                                        boxShadow: '0 6px 18px #012443',
                                                                        transform: 'translateY(-2px)'
                                                                    },
                                                                    transition: 'all 0.18s ease-in-out'
                                                                }}
                                                                startIcon={<i className="fa fa-upload" style={{ color: '#fff' }} />}
                                                            >
                                                                Importar Logo
                                                            </Button>
                                                        </label>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Card>


                            ) : (null)}

                            <div className="container">
                                <div className="row">
                                    <div className="col-4"></div>
                                    <div className="col-4"></div>
                                    <div className="col-4" style={{ display: 'flex', gap: '10px' }}>
                                        <div className="btn-class-cadastrar" style={{ flex: 1 }}>
                                            <Link to={"/embarcador"}>
                                                <BackButton />
                                            </Link>
                                        </div>
                                        <div className="btn-class-cadastrar" style={{ flex: 1 }}>
                                            {
                                                carregando ?
                                                    <div className="spinner-border text-danger" role="status">
                                                        <span className="visually-hidden ">Loading...</span></div>
                                                    :
                                                    <button disabled={view} type="submit" onClick={id ? update : save} className="w-100 btn btn-primary btn-cadastrar">salvar</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <Dialog
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">
                                    <h1>
                                        <i class="fa fa-exclamation-triangle" style={{ color: '#FEDE00' }} aria-hidden="true"></i>
                                        {title}
                                    </h1>

                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <h6> {msg} </h6>
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>

                                    <button
                                        type="button"
                                        onClick={handleClose}
                                        className="btn btn-primary btn-cadastrar"> Ok</button>

                                </DialogActions>
                            </Dialog>
                        </div>

                    </div>
                </div>
            } />
        </>
    )
}

export default NewEmbarcador;





